import { render, staticRenderFns } from "./ChiefDeptNavigationDrawer.vue?vue&type=template&id=a511b984"
import script from "./ChiefDeptNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./ChiefDeptNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports